import { postApi } from "./Api";

export const login = (payload) => {
  return postApi("/postAuth/login", payload)
    .then((data) => {
      return data;
    })
    .catch((err) => {
      throw err;
    });
};
